module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "arrow-left"
    },
    on: {
      "click": _vm.backtohome
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.operation !== 'add') ? [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.operation === 'edit',
      "icon": "edit"
    },
    on: {
      "click": _vm.editAPIGroup
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.operation === 'edit',
      "icon": "delete"
    },
    on: {
      "click": _vm.delAPIGroup
    }
  }, [_vm._v("删除")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "apigroups-body"
  }, [_c('el-form', {
    ref: "rulesForm",
    class: {
      detailsform: _vm.operation === 'detail'
    },
    attrs: {
      "model": _vm.apiGroup,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "xm": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "接口组编码",
      "prop": "GroupNO"
    }
  }, [(_vm.operation !== 'add') ? _c('span', [_vm._v(_vm._s(_vm.apiGroup.GroupNO))]) : _c('el-input', {
    attrs: {
      "placeholder": "接口组编码",
      "maxlength": 10,
      "size": "small"
    },
    model: {
      value: (_vm.apiGroup.GroupNO),
      callback: function($$v) {
        _vm.$set(_vm.apiGroup, "GroupNO", $$v)
      },
      expression: "apiGroup.GroupNO"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接口组描述",
      "prop": "GroupName"
    }
  }, [(_vm.operation === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.apiGroup.GroupName))]) : _c('el-input', {
    attrs: {
      "placeholder": "接口组描述",
      "maxlength": 18,
      "size": "small"
    },
    model: {
      value: (_vm.apiGroup.GroupName),
      callback: function($$v) {
        _vm.$set(_vm.apiGroup, "GroupName", $$v)
      },
      expression: "apiGroup.GroupName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "Memo"
    }
  }, [(_vm.operation === 'detail') ? _c('span', [_vm._v(_vm._s(_vm.apiGroup.Memo))]) : _c('el-input', {
    attrs: {
      "placeholder": "备注说明",
      "type": "textarea",
      "maxlength": 120
    },
    model: {
      value: (_vm.apiGroup.Memo),
      callback: function($$v) {
        _vm.$set(_vm.apiGroup, "Memo", $$v)
      },
      expression: "apiGroup.Memo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "apigroups-foot-btn"
  }, [(_vm.operation !== 'detail') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAddMsg
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.operation === 'edit') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6e32df26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/00299303/apiGroupsAdd.vue
// module id = yad7
// module chunks = 1